import React from 'react'

const ManageEditPreferredPortPairsDialogContext = React.createContext()

export default ManageEditPreferredPortPairsDialogContext